import script from "./RiskView.vue?vue&type=script&setup=true&lang=js"
export * from "./RiskView.vue?vue&type=script&setup=true&lang=js"

import "./RiskView.vue?vue&type=style&index=0&id=63c6b8d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c6b8d2"]])

export default __exports__